var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"},attrs:{"id":"app"}},[_c('router-view'),_c('v-overlay',{attrs:{"value":_vm.loadingMenu,"opacity":".9"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}}),_c('p',[_vm._v(_vm._s(_vm.loadMsg))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }